// Admin overlay state — small signals instead of prop-drilling through the tree.
// One module owns which admin surfaces are open; components read and set.
import { signal } from '@preact/signals';
import type { CallView } from './schedule';

/** Job Database row shape (GET /api/jobs). */
export interface JobRow {
  weekOf: string;
  day: string;
  dayLabel: string;
  date: string;
  id: string;
  slot: string;
  development: string;
  lot: string;
  address: string;
  problem: string;
  name: string;
  phone: string;
  instructions: string;
  tech: string;
  src: string;
  status: 'active' | 'done' | 'missed';
  completedAt: string;
  completedBy: string;
  note: string;
  needsReturn: boolean;
  photos: string[];
}

export interface EditSheetState {
  mode: 'add' | 'edit';
  id?: string;
  /** Prefill fields (existing call values, or defaults for add). */
  call: Partial<CallView>;
  day: string;
  /** Target week — v1 label or ISO id, sent as weekOf. */
  weekOf: string;
  /** Open from Job Database: shows the week selector (add: enabled, edit: fixed). */
  fromDb: boolean;
}

export const showHubSheet = signal(false); // phone admin hub (summary)
export const showJobsDb = signal(false);
export const jobDetail = signal<JobRow | null>(null);
export const showHistory = signal(false);
export const showReminders = signal(false);
export const returnFor = signal<{ id: string; development: string; address: string } | null>(null);
export const editSheet = signal<EditSheetState | null>(null);
export const showNewWeek = signal(false);

/** Bumped after any Job-Database mutation so an open DB sheet refetches. */
export const jobsRefresh = signal(0);
